import React from "react";
import { MODAL_STYLES } from "../../constants/modal-styles";
import { ModalButton } from "./ModalButton";

interface SelectMessageTypeModalProps {
  isOpen: boolean;
  language: "ka" | "en";
  onBack: () => void;
  onConfirm?: () => void;
}

export const SelectMessageTypeModal: React.FC<SelectMessageTypeModalProps> = ({
  isOpen,
  language,
  onBack,
  onConfirm,
}) => {
  if (!isOpen) return null;

  const content = {
    ka: {
      title: "აირჩიეთ შეტყობინება",
      back: "უკან",
      next: "შემდეგი",
    },
    en: {
      title: "Select a message",
      back: "Back",
      next: "Next",
    },
  };

  const text = content[language] || content.ka;

  return (
    <div className={MODAL_STYLES.bottomOverlay}>
      <div
        className={MODAL_STYLES.bottomModal}
        onClick={(e) => e.stopPropagation()}
        style={{ fontFamily: MODAL_STYLES.fontFamily, maxWidth: '400px' }}
      >
        <div className={MODAL_STYLES.content}>
          <h2 className="text-sm sm:text-base font-bold text-amber-900 mb-4 text-center">
            {text.title}
          </h2>
          <div className="flex flex-col sm:flex-row justify-center gap-2">
            <ModalButton onClick={onBack} fullWidth={false}>
              <span className="text-xs sm:text-sm">{text.back}</span>
            </ModalButton>
            {onConfirm && (
              <ModalButton onClick={onConfirm} fullWidth={false}>
                <span className="text-xs sm:text-sm">{text.next}</span>
              </ModalButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
